export const promoBanners = {
  promoBannerAlt: "促销横幅",
  promoBannerSlide: "幻灯片",
  tagDrop: "Drop",
  tagTorneo: "锦标赛",
  tagRace: "Race",
  tagNuevo: "新",
  tagPromo: "促销",
};
